export function TextInput({ name, label, data = "", type = "" }) {
  return (
    <div className={`input_wrapper ${type}`}>
      <label htmlFor={name}>{label}</label>
      <input id={name} name={name} defaultValue={data} />
    </div>
  );
}
